$(function () {
  'use strict';

  $.easing.easeOutQuint = function (x, t, b, c, d) {
    return c * ((t = t / d - 1) * t * t * t * t + 1) + b;
  };

  $('[data-provide=local-scroll]').localScroll({
    duration: 1000,
    easing: 'easeOutQuint'
  });

  Vue.transition('collapse', {
    enter: function (el, done) {
      // element is already inserted into the DOM
      // call done when animation finishes.
      $(el)
        .css('display', 'none')
        .slideDown(400, done);
    },
    enterCancelled: function (el) {
      $(el).stop();
    },
    leave: function (el, done) {
      // same as enter
      $(el).slideUp(400, done);
    },
    leaveCancelled: function (el) {
      $(el).stop();
    }
  });

  new Vue({
    el: '#programs',

    data: {
      data: [],
      sortKey: '',
      filterKey: '',
      searchQuery: '',
      reversed: false,
      page: 1,
      total: 0,
      perPage: 30,
      filterIds: [],
      advancedFilters: false,
      advancedSearch: false,
      DuracaoPrograma: '',
      TipoPrograma: '',
      EstrategiasOutras: false,
      EstrategiasOutrasValue: '',
      tags: {
        PopulacaoAlvoCriancas: false,
        PopulacaoAlvoAdolescentes: false,
        PopulacaoAlvoAdultos: false,
        PopulacaoAlvoIdosos: false,

        ContextoAplicacaoEscolar: false,
        ContextoAplicacaoFamiliar: false,
        ContextoAplicacaoComunitario: false,
        ContextoAplicacaoLaboral: false,
        ContextoAplicacaoRecreativo: false,

        PrevencaoConsumoSubstancias: false,
        PrevencaoConsumoSubstanciasAlcool: false,
        PrevencaoDependenciaJogo: false,
        PrevencaoPerturbacoesAlimentares: false,
        PrevencaoBullying: false,
        PrevencaoViolencia: false,
        PrevencaoSuicidio: false,
        PrevencaoComportamentosSexuaisRiscoGravidezAdulescencia: false,
        PrevencaoAbsentismoEscolar: false,
        PrevencaoRiscosPsicossociais: false,

        PromocaoAutoEstima: false,
        PromocaoCompetenciasComunicacao: false,
        PromocaoCompetenciasSocioEmocionais: false,
        PromocaoResiliencia: false,

        NivelIntervencaoUniversal: false,
        NivelIntervencaoSelectiva: false,
        NivelIntervencaoIndicada: false,

        EstrategiasSensibilizacao: false,
        EstrategiasPsicoeducacao: false,
        //EstrategiasTreinoCompetenciasSocioEmocionais: false,
        EstrategiasTreinoCompetenciasParentais: false,
        EstrategiasActividadesLazer: false,
        EstrategiasFormacaoProfessores: false,
        EstrategiasFormacaoPares: false,
        EstrategiasApoioPsicosocialIndividual: false,
        EstrategiasActividadesPares: false
      }
    },

    compiled: function () {
      var self = this;

      self.total = this.data.length;

      self.getFilters();
      self.fetchData();

      self.$watch('advancedSearch', function () {
        localStorage.setItem('advancedSearch', self.advancedSearch);
      });

      self.$watch('EstrategiasOutras', function () {
        if (!self.EstrategiasOutras) {
          self.EstrategiasOutrasValue = '';
        }
      });

      self.$watch('EstrategiasOutrasValue', function () {
        if (self.EstrategiasOutrasValue !== '') {
          self.EstrategiasOutras = true;
        }
      });
    },

    computed: {
      paginateData: function () {
        var index = (this.page - 1) * this.perPage;
        return this.filterData.slice(index, index + this.perPage);
      },

      pages: function () {
        var total = [],
          i = this.page;

        if (i === this.pageLength) {
          while (total.length <= 5 && i >= 1) {
            total.push(i);
            i--;
          }
        } else if ((i + 2) > this.pageLength) {
          while (total.length < 4 && i >= 1) {
            total.push(i);
            i--;
          }
        } else if ((i + 2) <= this.pageLength) {
          while (total.length < 3 && i >= 1) {
            total.push(i);
            i--;
          }
        }
        i = this.page + 1;
        while (i <= this.pageLength && total.length < 5) {
          total.push(i);
          i++;
        }
        return total.sort(function (a, b) {
          return a - b;
        });
      },
      pageLength: function () {
        return Math.ceil(this.filterData.length / this.perPage);
      },
      filterData: function () {
        var self = this;

        self.data = self.$options.filters.orderBy(self.data, self.sortKey, self.reversed);

        var data = self.$options.filters.filterBy(self.data, self.filterKey, 'in', 'NomeAutor', 'TituloPrograma', 'Tema', 'Percentagem');

        if (self.advancedFilters) {
          data = data.filter(function (item) {
            return self.filterIds.indexOf(item.id) >= 0;
          });
        }

        return data;
      }
    },

    methods: {
      sortBy: function (e, key) {

        var self = this;

        if (key === self.sortKey) {
          self.reversed = !self.reversed;
        } else {
          self.reversed = false;
        }

        self.sortKey = key;
        e.preventDefault();
      },
      fetchData: function () {
        var xhr = new XMLHttpRequest();
        var self = this;
        xhr.open('GET', '/programas/api/programs');
        xhr.onload = function () {
          self.data = JSON.parse(xhr.responseText);
        };
        xhr.send();
      },
      getPage: function (e, page) {
        e.preventDefault();

        var self = this;

        if (page <= self.pageLength && page > 0) {
          self.page = page;
        }
      },
      quickSearch: function (e, searchQuery) {
        e.preventDefault();

        var self = this;

        self.filterKey = searchQuery;
        self.saveFilters();
      },
      clearQuickSearch: function (e) {
        e.preventDefault();

        var self = this;

        self.searchQuery = '';
        self.filterKey = '';
        self.saveFilters();
      },
      search: function () {
        var self = this;

        $.ajax({
          dataType: 'json',
          url: '/programas/api/filter-programs',
          data: {
            DuracaoPrograma: self.DuracaoPrograma,
            TipoPrograma: self.TipoPrograma,
            tags: self.tags,
            EstrategiasOutras: self.EstrategiasOutrasValue
          },
          success: function (data) {
            self.filterIds = data;
            self.advancedFilters = true;

            self.saveFilters();
          }
        });

      },
      saveFilters: function () {
        var self = this;
        localStorage.setItem('filterKey', self.filterKey);
        //localStorage.setItem('advancedSearch', self.advancedSearch);
        localStorage.setItem('advancedFilters', self.advancedFilters);
        localStorage.setItem('DuracaoPrograma', self.DuracaoPrograma);
        localStorage.setItem('TipoPrograma', self.TipoPrograma);
        localStorage.setItem('tags', JSON.stringify(self.tags));
        localStorage.setItem('EstrategiasOutras', self.EstrategiasOutrasValue);
      },
      getFilters: function () {
        var self = this;

        if (localStorage.filterKey) {
          self.filterKey = localStorage.filterKey;
          self.searchQuery = localStorage.filterKey;
        }

        if (localStorage.advancedSearch === 'true') {
          self.advancedSearch = true;
        }

        if (localStorage.DuracaoPrograma) {
          self.DuracaoPrograma = localStorage.DuracaoPrograma;
        }

        if (localStorage.TipoPrograma) {
          self.TipoPrograma = localStorage.TipoPrograma;
        }

        if (localStorage.EstrategiasOutrasValue) {
          self.EstrategiasOutrasValue = localStorage.EstrategiasOutrasValue;
        }

        if (localStorage.tags) {
          self.tags = JSON.parse(localStorage.tags);
        }

        if (localStorage.advancedFilters === 'true') {
          self.search();
        }
      },
      clearSearch: function () {
        var self = this;

        self.DuracaoPrograma = '';
        self.TipoPrograma = '';
        self.tags =  {
          PopulacaoAlvoCriancas: false,
          PopulacaoAlvoAdolescentes: false,
          PopulacaoAlvoAdultos: false,
          PopulacaoAlvoIdosos: false,

          ContextoAplicacaoEscolar: false,
          ContextoAplicacaoFamiliar: false,
          ContextoAplicacaoComunitario: false,
          ContextoAplicacaoLaboral: false,
          ContextoAplicacaoRecreativo: false,

          PrevencaoConsumoSubstancias: false,
          PrevencaoConsumoSubstanciasAlcool: false,
          PrevencaoDependenciaJogo: false,
          PrevencaoPerturbacoesAlimentares: false,
          PrevencaoBullying: false,
          PrevencaoViolencia: false,
          PrevencaoSuicidio: false,
          PrevencaoComportamentosSexuaisRiscoGravidezAdulescencia: false,
          PrevencaoAbsentismoEscolar: false,
          PrevencaoRiscosPsicossociais: false,

          PromocaoAutoEstima: false,
          PromocaoCompetenciasComunicacao: false,
          PromocaoCompetenciasSocioEmocionais: false,
          PromocaoResiliencia: false,

          NivelIntervencaoUniversal: false,
          NivelIntervencaoSelectiva: false,
          NivelIntervencaoIndicada: false,

          EstrategiasSensibilizacao: false,
          EstrategiasPsicoeducacao: false,
          //EstrategiasTreinoCompetenciasSocioEmocionais: false,
          EstrategiasTreinoCompetenciasParentais: false,
          EstrategiasActividadesLazer: false,
          EstrategiasFormacaoProfessores: false,
          EstrategiasFormacaoPares: false,
          EstrategiasApoioPsicosocialIndividual: false,
          EstrategiasActividadesPares: false
        };
        self.EstrategiasOutras = false;
        self.EstrategiasOutrasValue = '';
        self.advancedFilters = false;
        self.saveFilters();
      }

    },

    filters: {
      percentage: function (value) {
        var percentage = value * 100;

        return (Math.round(percentage * 100) / 100) + '%';
      }
    }
  });

});